const generateAxPalette = palette => ({
  '--button-primary-hover': palette.primaryDark,
  '--header-bg-color': palette.primary,
  '--header-text-color': palette.white,
  '--grey-3': palette.grey3,
  '--button-primary-disabled-shadow': `0 1px 3px 0 ${palette.boxShadow1}`,
  '--input-border': `1px solid ${palette.grey4}`,
  '--input-inset': palette.inputInset,
  '--input-outline': palette.inputOutline,
  '--grey-5': palette.grey5,
  '--font-color': palette.grey1,
  '--grey-2': palette.grey2,
  '--grey-6': palette.grey6,
  '--icon-box-shadow': `0 16px 32px 0 ${palette.primary}52`,
  '--avatar-ring-border': `1px solid ${palette.grey2}`,
  '--list-item-border': `1px solid ${palette.grey4}`,
  '--uploader-box-shadow': `0 8px 32px 0 ${palette.primary}52`,
  '--box-shadow-200': palette.boxShadow2,
});

export default generateAxPalette;
